import { initVueAppOnLoad } from '@/app'
import App from '@/views/SiteFooter.vue'

initVueAppOnLoad('#site-footer-app', App)
